var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1287,
    height: 595,
    viewBox: "0 0 1287 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_1526_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.19 535.747C1237.26 537.576 1240.42 537.38 1242.25 535.311L1272.04 501.588C1273.87 499.518 1273.68 496.359 1271.61 494.53C1269.54 492.702 1266.38 492.897 1264.55 494.967L1238.06 524.943L1208.09 498.458C1206.02 496.629 1202.86 496.825 1201.03 498.894C1199.2 500.964 1199.4 504.123 1201.47 505.952L1235.19 535.747ZM1238.18 526.899L1243.18 526.591L1238.18 526.899ZM694.336 230.894L691.766 226.605L694.336 230.894ZM428.941 389.935L431.511 394.224L428.941 389.935ZM64.0803 0.676319C58.8704 8.15455 54.0853 15.693 49.712 23.2768L58.3748 28.2724C62.6037 20.939 67.2358 13.6408 72.2854 6.39262L64.0803 0.676319ZM27.3301 71.9647C21.2669 89.3628 17.165 106.817 14.8667 124.153L24.78 125.467C26.9891 108.804 30.9336 92.0119 36.7731 75.2556L27.3301 71.9647ZM13.3798 177.768C14.7548 195.779 17.991 213.434 22.8893 230.524L32.5022 227.768C27.7852 211.312 24.6728 194.324 23.3508 177.007L13.3798 177.768ZM42.6134 280.357C50.7669 296.285 60.4194 311.419 71.3665 325.542L79.2702 319.415C68.6977 305.776 59.3809 291.167 51.515 275.8L42.6134 280.357ZM107.909 364.682C121.248 376.572 135.685 387.239 151.016 396.465L156.173 387.897C141.381 378.996 127.446 368.7 114.563 357.217L107.909 364.682ZM199.38 419.559C216.093 425.618 233.485 430.057 251.359 432.663L252.802 422.768C235.617 420.262 218.883 415.992 202.788 410.158L199.38 419.559ZM304.95 434.856C322.403 433.752 340.098 430.856 357.87 426L355.235 416.353C338.117 421.03 321.094 423.814 304.319 424.876L304.95 434.856ZM407.978 407.009C415.844 403.165 423.693 398.908 431.511 394.224L426.37 385.646C418.793 390.187 411.194 394.307 403.588 398.024L407.978 407.009ZM431.511 394.224L453.627 380.97L448.487 372.392L426.37 385.646L431.511 394.224ZM497.86 354.463L542.092 327.956L536.952 319.379L492.719 345.886L497.86 354.463ZM586.325 301.45L630.557 274.943L625.417 266.365L581.184 292.872L586.325 301.45ZM674.79 248.436L696.906 235.182L691.766 226.605L669.649 239.858L674.79 248.436ZM696.906 235.182C704.147 230.844 711.519 226.8 719.005 223.055L714.53 214.112C706.818 217.97 699.224 222.135 691.766 226.605L696.906 235.182ZM765.631 204.004C781.679 198.831 798.054 194.905 814.61 192.237L813.019 182.364C795.964 185.113 779.095 189.157 762.564 194.486L765.631 204.004ZM864.804 188.02C881.573 187.889 898.374 189.028 915.06 191.451L916.496 181.555C899.308 179.059 882 177.885 864.726 178.021L864.804 188.02ZM964.211 202.456C972.217 204.9 980.16 207.657 988.023 210.727L991.661 201.412C983.561 198.249 975.379 195.41 967.131 192.892L964.211 202.456ZM988.023 210.727L993.039 212.686L996.676 203.37L991.661 201.412L988.023 210.727ZM1003.07 216.602L1008.09 218.561L1011.72 209.246L1006.71 207.287L1003.07 216.602ZM1008.09 218.561C1015.96 221.634 1023.67 224.969 1031.23 228.555L1035.52 219.521C1027.75 215.834 1019.81 212.405 1011.72 209.246L1008.09 218.561ZM1075.1 253.333C1089.18 262.667 1102.51 272.952 1115 284.084L1121.66 276.616C1108.81 265.171 1095.1 254.596 1080.62 244.998L1075.1 253.333ZM1150.15 320.18C1161 333.029 1170.92 346.634 1179.84 360.887L1188.32 355.582C1179.15 340.928 1168.94 326.94 1157.79 313.73L1150.15 320.18ZM1203.47 405.383C1210.25 420.683 1215.97 436.516 1220.56 452.777L1230.18 450.063C1225.47 433.343 1219.59 417.063 1212.61 401.331L1203.47 405.383ZM1230.75 502.117C1231.85 510.407 1232.67 518.775 1233.19 527.208L1243.18 526.591C1242.64 517.921 1241.8 509.319 1240.66 500.795L1230.75 502.117ZM1233.19 527.208L1233.27 528.483L1243.25 527.866L1243.18 526.591L1233.19 527.208ZM1233.43 531.034L1233.51 532.309L1243.49 531.692L1243.41 530.416L1233.43 531.034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_1526_18",
    x: 0.379883,
    y: 0.67627,
    width: 1285.92,
    height: 594.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1526_18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1526_18",
    result: "effect2_dropShadow_1526_18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 29
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1526_18",
    result: "effect3_dropShadow_1526_18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 45
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1526_18",
    result: "effect4_dropShadow_1526_18"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1526_18",
    result: "effect5_dropShadow_1526_18"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_1526_18",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine4);
export default __webpack_public_path__ + "static/media/Line 4.d859a00393f345590c185364452c9f2b.svg";
export { ForwardRef as ReactComponent };